// Brazilian Portuguese translations for Game Prediction Modal
export const gamePredictionModalPtBR = {
  // Main modal
  'AI Game Prediction': 'Previsão de Jogos com IA',
  'Building your comprehensive analysis...': 'Construindo sua análise completa...',
  
  // Spin indicators - Basic users
  'free spin remaining today': 'giro grátis restante hoje',
  'Daily free spin used': 'Giro grátis diário usado',
  'Use AI to analyze today\'s games and get expert betting predictions': 'Use IA para analisar os jogos de hoje e obter previsões de apostas especializadas',
  
  // Spin indicators - Pro users
  'spin': 'giro',
  'spins': 'giros',
  'remaining': 'restantes',
  'Resets': 'Reinicia',
  'soon': 'em breve',
  'Spin limit reached • Click for info': 'Limite de giros atingido • Clique para informações',
  'Select a sport to get AI-powered predictions for today\'s best bets': 'Selecione um esporte para obter previsões com IA para as melhores apostas de hoje',
  
  // Sport names
  'MLB': 'MLB',
  'NFL': 'NFL', 
  'NCAAF': 'NCAAF',
  'Soccer': 'Futebol',
  'MLS': 'MLS',
  'Brasileirão': 'Brasileirão',
  'NBA': 'NBA',
  'NHL': 'NHL',
  'NCAA': 'NCAA',
  'NBA Finals': 'Finais da NBA',
  
  // Sport status
  'Out of Season': 'Fora de Temporada',
  
  // Star Coins section
  'Use Star Coins': 'Usar Star Coins',
  'Balance': 'Saldo',
  'Run another prediction for': 'Execute outra previsão por',
  'Run a prediction for': 'Execute uma previsão por',
  'Star Coins': 'Star Coins',
  'Processing...': 'Processando...',
  'Continue with Star Coins': 'Continuar com Star Coins',
  'Buy Star Coins': 'Comprar Star Coins',
  
  // Limit reached popup
  'Spin Limit Reached': 'Limite de Giros Atingido',
  'You\'ve used your 1 free AI prediction for today.': 'Você usou sua 1 previsão de IA gratuita para hoje.',
  'You\'ve used all 7 of your AI prediction spins for now.': 'Você usou todos os 7 giros de previsão de IA por enquanto.',
  'Your spins will reset at:': 'Seus giros serão reiniciados às:',
  '24 hours from last use': '24 horas desde o último uso',
  '2 hours from last use': '2 horas desde o último uso',
  'in': 'em',
  
  // Upgrade section
  'Pro Upgrade Benefits:': 'Benefícios do Upgrade Pro:',
  '7 free predictions every 3 hours': '7 previsões gratuitas a cada 3 horas',
  'Priority access to premium features': 'Acesso prioritário a recursos premium',
  'Advanced statistics and analysis': 'Estatísticas e análises avançadas',
  'Upgrade to Pro': 'Fazer Upgrade para Pro',
  'Upgrade to Pro - Get 7 Spins Every 3 Hours': 'Upgrade para Pro - Obtenha 7 Giros a Cada 3 Horas',
  'Want more predictions without using Star Coins?': 'Quer mais previsões sem usar Star Coins?',
  
  // Buttons
  'Got it': 'Entendi',
  'Close': 'Fechar',
  'Upgrade for More Spins': 'Upgrade para Mais Giros',
  
  // Analysis steps
  'Finding Best': 'Encontrando Melhor',
  'Game': 'Jogo',
  'Select Sport': 'Selecionar Esporte',
  'Generating Comprehensive Prediction': 'Gerando Previsão Completa',
  'Finalizing Analysis': 'Finalizando Análise',
  
  // Microsteps
  'Scanning today\'s matchups...': 'Analisando os confrontos de hoje...',
  'Analyzing opening lines...': 'Analisando linhas de abertura...',
  'Identifying value opportunities...': 'Identificando oportunidades de valor...',
  'Ranking game potential...': 'Classificando potencial dos jogos...',
  'Gathering latest news and stats...': 'Coletando últimas notícias e estatísticas...',
  'Processing team and player data...': 'Processando dados de equipes e jogadores...',
  'Building prediction model...': 'Construindo modelo de previsão...',
  'Running simulations...': 'Executando simulações...',
  'Calculating win probabilities...': 'Calculando probabilidades de vitória...',
  'Determining confidence level...': 'Determinando nível de confiança...',
  'Finalizing recommendation...': 'Finalizando recomendação...',
  'Preparing detailed report...': 'Preparando relatório detalhado...',
  
  // Completion
  'Prediction Complete': 'Previsão Completa',
  'Your comprehensive analysis is ready to view': 'Sua análise completa está pronta para visualização',
  'Spin Reset Info': 'Informações de Reinício de Giros',
  
  // Time formatting
  'h': 'h',
  'm': 'min',
  'Soon': 'Em breve',
  
  // Error messages
  'Failed to use Star Coins. Please try again.': 'Falha ao usar Star Coins. Por favor, tente novamente.',
  'An unexpected error occurred. Please try again.': 'Ocorreu um erro inesperado. Por favor, tente novamente.',
  'insufficient': 'insuficiente'
};